// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-template/src/index.tsx

import { baseIcon, defaultIconGroupProps } from '@bubble-ui/temp-icon-base';
import { isWaffle, isWhiteLabel } from '@bubble-ui/particle-design-versions';
var IconTransferPathPancake = 'M12.245 0 11.17 7.46h8.08L7.755 20l1.075-7.46H.75L12.245 0ZM5.34 10.526h5.831l-.47 3.269 3.96-4.321H8.83l.47-3.269-3.96 4.321Z';
var IconTransferPathWaffle = 'm8.354 19.19-.019-6.837-6.602-.938L11.646.81l.019 6.837 6.602.939L8.354 19.19Zm-3.217-8.975 4.861.69.01 4.073 4.855-5.193-4.861-.69-.011-4.073-4.854 5.193Z';
var IconTransferPathWaffleFilled = 'm8.354 19.19-.019-6.837-6.602-.938L11.646.81l.019 6.837 6.602.939L8.354 19.19Z';
var IconTransferPathWhiteLabel = 'm5.836 18.17 2.92-5.94L2.63 11.2l9.874-9.37h1.66l-2.946 5.976 6.14 1.02-9.864 9.343h-1.66Zm3.985-4.46 4.02-3.795-5.031-.854 1.368-2.766-4.034 3.835 5.031.844-1.354 2.736Z';
var IconTransferPathWhiteLabelFilled = 'm5.836 18.17 2.92-5.94L2.63 11.2l9.874-9.37h1.66l-2.946 5.976 6.14 1.02-9.864 9.343h-1.66Z';
var IconTransferViewBoxWaffle = {
  viewBoxWidth: 20,
  viewBoxHeight: 20
};
var IconTransferViewBoxWaffleFilled = {
  viewBoxWidth: 20,
  viewBoxHeight: 20
};
var IconTransferViewBoxWhiteLabel = {
  viewBoxWidth: 20,
  viewBoxHeight: 20
};
var IconTransferViewBoxWhiteLabelFilled = {
  viewBoxWidth: 20,
  viewBoxHeight: 20
};
export var IconTransfer = baseIcon('IconTransfer', {
  groupProps: defaultIconGroupProps,
  getPath: _ref => {
    var {
      designVersion,
      filled
    } = _ref;
    return isWhiteLabel(designVersion) ? filled ? IconTransferPathWhiteLabelFilled : IconTransferPathWhiteLabel : isWaffle(designVersion) ? filled ? IconTransferPathWaffleFilled : IconTransferPathWaffle : IconTransferPathPancake;
  },
  shapeSize: _ref2 => {
    var {
      designVersion,
      filled
    } = _ref2;
    return isWhiteLabel(designVersion) ? filled ? IconTransferViewBoxWhiteLabelFilled : IconTransferViewBoxWhiteLabel : isWaffle(designVersion) ? filled ? IconTransferViewBoxWaffleFilled : IconTransferViewBoxWaffle : {};
  }
});
//# sourceMappingURL=index.js.map